import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

/**
 * Generated class for the AdnSettingsPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'adnSettings',
})
export class AdnSettingsPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(options) {
    const overrides: any = {
      site: '1120900',
    };

    if (_.get(window, '$user.jobSearchInfo.zip')) {
      overrides.keywords = [_.get(window, '$user.jobSearchInfo.zip')];
    }

    return _.merge({}, options || {}, overrides);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/adn-settings/adn-settings.ts